import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { isNoColorProduct } from '@as-react/common-utils';
import { TextAlpha, SwatchSelector, Stack } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetAvailableColors, makeGetProductDefaults, makeGetSelectedColorId, } from '../../../redux/product/selectors/ProductSelector';
import { getSwatchUrlByProductCode } from '../../../util/ImageUtil';
export const getDiscountIconContent = (productSwatch, productSwatchConfig) => {
    let iconContent = '';
    if (productSwatch.hasDiscount) {
        iconContent = productSwatchConfig.actionLabel;
        if (productSwatch.markdown) {
            iconContent = productSwatchConfig.saleLabel;
        }
    }
    return iconContent;
};
export const generateSwatchFromProductColorVariation = (productColorVariation, selectedColorId, productCode, productImageConfig, swatchInformation, isShopLanding) => ({
    id: `${productCode}-${productColorVariation.colorId}`,
    value: productColorVariation.colorId.toString(),
    colourId: productColorVariation.colorId,
    color: productColorVariation.translations.description,
    extendedRange: productColorVariation.webOnly,
    swatch: getSwatchUrlByProductCode(productCode, productColorVariation.swatch, productImageConfig),
    imageUrl: getSwatchUrlByProductCode(productCode, productColorVariation.swatch, productImageConfig),
    selected: selectedColorId === productColorVariation.colorId,
    hasDiscount: Boolean(productColorVariation.hasDiscount),
    hasPermanentDiscount: Boolean(productColorVariation.markdown),
    outOfStock: productColorVariation.availability === 0,
    overlay: getDiscountIconContent(productColorVariation, swatchInformation),
    status: isShopLanding && productColorVariation.webOnly ? 'extendedRange' : undefined,
    title: productColorVariation.translations.description,
    size: 'sm',
    lazyLoad: true,
});
export const ColorSwatches = ({ enableShopTheLook }) => {
    const { feature_toggles: { categorized_product_features }, pageInfo: { isPDPPage }, productImageConfig, productSwatchConfig, isShopLanding, } = useAemConfig();
    const dispatch = useDispatch();
    const colors = useSelector(makeGetAvailableColors());
    const productCode = useSelector(makeGetProductDefaults()).productCode;
    const selectedColorId = useSelector(makeGetSelectedColorId());
    useEffect(() => {
        if (isPDPPage && categorized_product_features && selectedColorId) {
            dispatch(productActions.createGetTechnicalCategories(selectedColorId));
        }
    }, []);
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const swatches = colors.map((productColor) => generateSwatchFromProductColorVariation(productColor, selectedColorId, productCode, productImageConfig.cdnDomains, productSwatchConfig, isShopLanding));
    const selectedColorVariation = colors.find((colorVariation) => colorVariation.colorId === selectedColorId);
    const hasColor = selectedColorVariation && !isNoColorProduct(selectedColorVariation);
    const setProductColor = (colourId) => {
        dispatch(productActions.createSetColorAction(colourId));
        if (isPDPPage && categorized_product_features) {
            dispatch(productActions.createGetTechnicalCategories(colourId));
        }
        if (enableShopTheLook) {
            dispatch(productActions.createGetLinkedProducts(colourId));
        }
    };
    const handleChange = (colourId) => {
        if (Number(colourId) !== selectedColorId) {
            setProductColor(Number(colourId));
        }
    };
    return (_jsxs(Stack, { gap: "1", direction: "col", children: [hasColor ? (_jsxs(Stack, { gap: "1", children: [_jsxs(TextAlpha, { strong: true, children: [t('product:pdp.color'), ": "] }), _jsx(TextAlpha, { color: "emphasised", testId: "color_name", children: selectedColorVariation === null || selectedColorVariation === void 0 ? void 0 : selectedColorVariation.translations.description })] })) : null, swatches && swatches.length > 1 && (_jsx(SwatchSelector, { name: `color_swatch_${productCode}`, testId: "swatch-selector", defaultValue: String(selectedColorId), onChange: handleChange, swatches: swatches }))] }));
};
